import React, { useEffect, useState } from 'react'; // useEffectとuseStateをインポート
import { Helmet } from 'react-helmet-async'; // ★これと
import styled from 'styled-components';
import { device } from '../MainContents/Style/StyleDevice';
import EntranceExamInfo from './EntranceExamInfo';


const AdmissionHighSchool = () => {
    return (
        <div className='mt-40 mb-20 text-center h-screen'>
            <Helmet>
                <title>TOSAYOBI高等学院 | 高知の通信制高校</title> {/* ←ここに希望するタイトルを設定 */}
                <meta name="description" content="TOSAYOBI高等学院の公式ウェブサイトです。高知で通信制高校をお探しの方へ。" />
                {/* 必要であれば、OGPタグなどもここに追加できます */}
                <meta property="og:title" content="TOSAYOBI高等学院" />
                <meta property="og:description" content="高知県で大学受験対策もできる通信制高校をお探しならTOSAYOBI高等学院。土佐塾予備校のノウハウで、一人ひとりに寄り添い高卒資格と志望大学合格をサポートします。" />
                <meta property="og:keywords" content="高知,予備校,入試,通信制" />
                {/* <meta property="og:image" content="ここにOGP画像のURL" /> */}
            </Helmet>
            <h2 className='text-5xl text-gray-600 pt-20 font-bold'>
                入学をお考えの方
            </h2>
                <div className="">
      <div className="max-w-4xl mx-auto px-4 mt-5">
        <EntranceExamInfo />
        </div>
        </div>
            <p className='mt-5 text-black text-2xl font-bold pl-4'>２０２６・２０２７年度</p>
            <p className='text-black text-2xl font-bold pl-4'>入試の日程・出願～入学までのながれ</p>
            <div className='mt-10 mb-40'>
                <a href='/pdf/students_offering2026-2027.pdf' className='bg-red-700 border-2 rounded-lg text-xl md:text-3xl tracking-widest text-white p-3'>
                    <span class="material-symbols-outlined pr-2">picture_as_pdf</span>
                    生徒募集要項はこちら
                </a>
            </div>
        </div>
    );
};

export default AdmissionHighSchool;
